module.exports = __webpack_public_path__ + "img/vegetable-cabbage-190x100.1db58fbd.jpg";